import Svg, { Path, type SvgProps } from 'react-native-svg'

export function BankAccountManagement(props: SvgProps) {
  return (
    <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <Path
        d="M2.5 18.3333H17.5"
        stroke={props.color ?? '#223843'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5 15.0001V9.16675"
        stroke={props.color ?? '#223843'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8.33301 15.0001V9.16675"
        stroke={props.color ?? '#223843'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M11.667 15.0001V9.16675"
        stroke={props.color ?? '#223843'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15 15.0001V9.16675"
        stroke={props.color ?? '#223843'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9.99967 1.66675L16.6663 5.83341H3.33301L9.99967 1.66675Z"
        stroke={props.color ?? '#223843'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
